"use strict";

/**
 * 数量 +/- ボタンのクリックで、対象 input の値を増減して change イベントを発火する
 * hidden クラスのない form-field 内の input を優先して取得する
 * @param {MouseEvent} e
 */
function handleQtyButtonClick(e) {
  var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
  if (!btn) return;
  var wrapper = btn.closest('[data-quantity-wrapper]');
  if (!wrapper) return;
  var input =
    wrapper.querySelector('.form-field:not(.hidden) [data-quantity-input]') ||
    wrapper.querySelector('.form-field:not(.hidden) [data-quantity-select]') ||
    wrapper.querySelector('[data-quantity-input]');
  if (!input) return;
  var min = parseInt(input.min, 10) || 1;
  var current = parseInt(input.value, 10) || 1;
  var next = btn.hasAttribute('data-qty-plus') ? current + 1 : Math.max(min, current - 1);
  if (next === current) return;
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

document.addEventListener('click', handleQtyButtonClick);